/* ==========================================================================
   Rook UI Core — Bottom App Bar Controller
   Web Component: <rk-bottom-app-bar-element>
   ========================================================================== */

if (!customElements.get('rk-bottom-app-bar-element')) {
    class RkBottomAppBarElement extends HTMLElement {
        constructor() {
            super();
            this.items = [];
            this._onKeyDown = this._onKeyDown.bind(this);
        }

        connectedCallback() {
            // Setup Menubar Role if missing
            if (!this.hasAttribute('role')) {
                this.setAttribute('role', 'menubar');
            }

            this.items = Array.from(this.querySelectorAll('[role="menuitem"]'));

            // Allow focus only on the first item initially
            this.items.forEach((item, index) => {
                if (index === 0) {
                    item.setAttribute('tabindex', '0');
                } else {
                    item.setAttribute('tabindex', '-1');
                }
            });

            this.addEventListener('keydown', this._onKeyDown);
        }

        disconnectedCallback() {
            this.removeEventListener('keydown', this._onKeyDown);
        }

        /* ------------------------------------------------------------------ */
        /*  Roving Tabindex & ARIA Keyboard Navigation                        */
        /* ------------------------------------------------------------------ */

        _onKeyDown(e) {
            const currentItem = document.activeElement;
            const currentIndex = this.items.indexOf(currentItem);

            if (currentIndex === -1) return; // Focus isn't on an item

            let nextIndex = currentIndex;

            switch (e.key) {
                case 'ArrowRight':
                    e.preventDefault();
                    nextIndex = (currentIndex + 1) % this.items.length;
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    nextIndex = (currentIndex - 1 + this.items.length) % this.items.length;
                    break;
                case 'Home':
                    e.preventDefault();
                    nextIndex = 0;
                    break;
                case 'End':
                    e.preventDefault();
                    nextIndex = this.items.length - 1;
                    break;
                case 'ArrowUp':
                    // If the item controls a popover or dropdown, we might proxy it
                    // But usually, standard Enter/Space handles trigger. The PRD mentions ArrowUp logic for menus.
                    // If there's an upward popover attached, we simulate a click or open it.
                    if (currentItem.hasAttribute('aria-haspopup')) {
                        e.preventDefault();
                        currentItem.click();
                    }
                    return; // Early return, don't move focus right/left
                default:
                    return; // Ignore other keys
            }

            // Move focus
            this.items[currentIndex].setAttribute('tabindex', '-1');
            this.items[nextIndex].setAttribute('tabindex', '0');
            this.items[nextIndex].focus();
        }
    }

    customElements.define('rk-bottom-app-bar-element', RkBottomAppBarElement);
}
